// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"b770d21d","496":"34cd1e2f","513":"acdb15b8","514":"74e85747","703":"03a00f3d","705":"c415774d","893":"745ab1b1"}[chunkId] + ".chunk.js";
};